import { render, staticRenderFns } from "./AddressFormComponent.vue?vue&type=template&id=bb6d593c"
import script from "./AddressFormComponent.vue?vue&type=script&lang=js"
export * from "./AddressFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports